import { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import "./MenuForm.css";
import "../../globalStyles/ControlElementsStyles.css";
import { Context } from "../../index";
import Logo from "../../assets/logo.svg";
import { useNavigate } from "react-router-dom";
import NavigationPanel from "./NavigationMenu/NavigationPanel";
import ArrowDown from "../../assets/arrowDown.svg";
import "./NavigationMenu/NavigationPanel.css";

const MenuForm = () => {
    const { store } = useContext(Context);
    const navigate = useNavigate();
    const linkForManual = "https://wiki.bpmlab.ru/doc/rukovodstvo-polzovatelya-dRyZh90XbW";
    const [companyLogo, setCompanyLogo] = useState<string | undefined>("");
    const [menuCollapsed, setMenuCollapsed] = useState<boolean>(store.leftMenuCollapsed);

    function goToProject() {
        navigate("/projects");
    }

    useEffect(() => {
        (async () => {
            try {
                await store.getSystemSettings();
                const picture = await store.commonService.getSystemLogo();
                setCompanyLogo(picture.data?.length > 0 ? picture.data : Logo);
            } catch (error) {
                console.error(error);
            }
        })();
    }, []);

    const toggleMenu = () => {
        setMenuCollapsed(!menuCollapsed);
        store.setLeftMenuCollapsed(!menuCollapsed); 
    };

    return (
        <div className={`menu-container ${menuCollapsed ? "collapsed" : ""}`}>
            <div className="menu-header">
                <img className="logo" alt="logo" src={companyLogo} onClick={goToProject} />
                <button className="collapse-button" onClick={toggleMenu}>
                    <img src={ArrowDown} alt="arrow" style={{ rotate: menuCollapsed ? "270deg" : "90deg" }} />
                </button>
            </div>

            <div className="menu-nav-panel">
                <NavigationPanel collapsed={menuCollapsed} />
            </div>
            {!menuCollapsed ? (
                <div className="menu-footer">
                    <Link className="wiki-link" to={linkForManual}>
                        Руководство пользователя
                    </Link>
                </div>
            ) : (
                <div className="menu-user-manual">
                    <div className="nav-panel">
                        <Link className="nav-panel_item" to={linkForManual} title="Руководство пользователя">
                            <div className="nav-panel_label-container">
                                <div className="image-manual user-manual" />
                            </div>
                        </Link>
                    </div>
                </div>
            )}
        </div>
    );
};

export default observer(MenuForm);
